<template>
  <div class="col-12 col-md-7">
    <div class="mid-container">
      <NavMenu/>
      <main class="content">
          <div class="row">
            <div class="col-12">
              <div class="tittle-content">
                <img class="subtittle-img" src="../assets/img/credito-simple-gf.webp" alt="Con Obligado Solidario y Garantía Fiduciaria">
              </div>
            </div>
            <div class="col-12 col-md-10">
              <img class="credito-table-img" src="../assets/img/credito-simple-table.webp" alt="Tabla de crédito">
            </div>
            <div class="col-12 col-md-8">
              <p class="general-text">La <strong>tasa de interés</strong> y el <strong>CAT</strong> son variables y dependerá de cada caso en concreto por lo que deberán acercarse directamente a la entidad <i>Financiera Sihusel, S.A. de C.V. SOFOM, E.N.R.</i> para que se realice el cálculo correspondiente.</p>
            </div>
            <div class="col-12 col-md-2">
              <p class="btn-crealo-orange"><router-link to="/Creditos/Calculadora-Credito">Créalo</router-link></p>
            </div>
          </div>
      </main>
      <FooterSihusel/>
    </div>
  </div>
  <div class="d-none d-md-block col-4">
    <div class="right-container slider-credito-gf">
    </div>
  </div>
</template>

<script>
import FooterSihusel from './FooterSihusel.vue';
import NavMenu from './NavMenu.vue';

export default {
  name: 'CreditoSimpleGFComponent',
  components: {
    NavMenu,
    FooterSihusel
  }
}
</script>

